// src/components/asset-inventory.jsx
import React, { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

const GOLD = '#B8860B';
const NAVY = '#001F3F';

export default function AssetInventory({ stylistId }) {
  const [unlocked, setUnlocked] = useState([]);
  const [activeAsset, setActiveAsset] = useState(null);

  useEffect(() => {
    return onSnapshot(doc(db, 'barbers', stylistId), (snap) => {
      if (snap.exists()) setUnlocked(snap.data().purchasedAssets || []);
    });
  }, [stylistId]);

  return (
    <div style={panel}>
      <h3 style={{color: GOLD, marginBottom: '20px'}}>3D INVENTORY</h3>
      {unlocked.length === 0 ? (
        <p style={{opacity: 0.5}}>No assets purchased yet.</p>
      ) : (
        <div style={grid}>
          {unlocked.map((url, idx) => (
            <div 
              key={idx} 
              style={{
                ...assetThumb, 
                border: activeAsset === url ? `2px solid ${GOLD}` : '1px solid #333'
              }}
              onClick={() => setActiveAsset(url)}
            >
              <img src={url} style={{width: '100%', height: '100%', objectFit: 'cover'}} />
              {activeAsset === url && <div style={check}>ACTIVE</div>}
            </div>
          ))}
        </div>
      )}
      
      {activeAsset && (
        <div style={applyBox}>
          <p style={{fontSize: '0.8rem'}}>Texture Selected: Ready for StyleSnap</p>
          <button style={useBtn}>Apply to New Style</button>
        </div>
      )}
    </div>
  );
}

const panel = { background: 'rgba(255,255,255,0.05)', padding: '20px', borderRadius: '20px' };
const grid = { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(80px, 1fr))', gap: '10px' };
const assetThumb = { height: '80px', borderRadius: '10px', overflow: 'hidden', cursor: 'pointer', position: 'relative' };
const check = { position: 'absolute', inset: 0, background: 'rgba(184,134,11,0.6)', display: 'grid', placeItems: 'center', fontSize: '10px', fontWeight: 'bold' };
const applyBox = { marginTop: '20px', paddingTop: '20px', borderTop: '1px solid rgba(255,255,255,0.1)' };
const useBtn = { width: '100%', background: GOLD, border: 'none', padding: '10px', borderRadius: '8px', fontWeight: 'bold' };
